import React, { useState, useEffect, useLayoutEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import { Hi, LangActivity, LangLogout, LangSetting, AttendanceReview, LangAttendanceRevision, LangAttendanceApproval, LangNoNotification, LangNotification, LangPaidLeaveRequest, LangUnpaidLeaveRequest, LangEmployeeDocsExpired, LangEmployeeDocsInReminder, LangClaimRequest, LangPintuKerjooAttendanceApproval, LangDeviceApproval, LangProfilePhotoApproval, LangScheduleDemo, Dashboard } from '../../constant/languange'
import { mapStateToProps, connect, axiosCompany, mapDispatchToProps, cookies, SpinnerButton, handleDarkMode, checkAuthorization } from '../../helpers/Common'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faHistory, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom'
import { COOKIES_PERMISSION_APPROVAL } from '../../constant/CommonConstant'

const Rightbar = (props) => {
  const history = useHistory()

  const [logout, setLogout] = useState(false)
  const [onLogout, setOnLogout] = useState(false)
  const propsName = props.redux.profile.name
  const limitName = propsName.split('')
  const name = limitName.slice(0, 8).join('')
  const [widthWindow, setWidthWindow] = useState(null)
  const [notificationCount, setNotificationCount] = useState(0)

  const updateDimensions = () => {
    setWidthWindow(window.innerWidth)
  }

  const removeCookies = () => {
    const coockiesName = ['annual_label_id', 'annual_label_en', 'token', 'session_id', 'payroll_pass', 'dismiss_alert_payroll_password', COOKIES_PERMISSION_APPROVAL]
    coockiesName.forEach(item => cookies.remove(item))
    // cookies.remove('annual_label_id')
    // cookies.remove('annual_label_en')
    // cookies.remove('token')
    // cookies.remove('sesion_id')
    window.localStorage.removeItem('filterPersonnel')
  }

  useLayoutEffect(() => {
    const mode = cookies.get('mode')
    handleDarkMode(mode, props)
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (logout) {
      setOnLogout(true)
      axiosCompany().post('auth/logout').then(() => {
        removeCookies()
        window.location.reload()
      })
    }

    updateDimensions()
    window.addEventListener('resize', updateDimensions)

    return () => window.removeEventListener('resize', updateDimensions)
  }, [logout, widthWindow])

  useEffect(() => {
    let count = 0
    for (const [key, value] of Object.entries(props.redux.notifications)) {
      // if (key !== 'personnel_document') {
      // count += value
      // }
      if (key === 'attendance_review' && checkAuthorization(props.redux, 'attendance-review.index')) {
        count += value
      }
      if (key === 'attendance_edit_request' && checkAuthorization(props.redux, 'attendance-revision.index')) {
        count += value
      }
      if (key === 'unlock_limit_attenance_request' && checkAuthorization(props.redux, 'attendance-approval.index')) {
        count += value
      }
      if (key === 'update_profile_picture' && checkAuthorization(props.redux, 'picture-approval.index')) {
        count += value
      }
      if (key === 'whitelist_device' && checkAuthorization(props.redux, 'device-approval.index')) {
        count += value
      }
      if (key === 'leave_request' && checkAuthorization(props.redux, 'paid-leave.day.index')) {
        count += value
      }
      if (key === 'permit_request' && checkAuthorization(props.redux, 'unpaid-leave.day.index')) {
        count += value
      }
      if (key === 'personnel_document_expired' && checkAuthorization(props.redux, 'employee.doc.index')) {
        count += value
      }
      if (key === 'personnel_document_in_reminder' && checkAuthorization(props.redux, 'employee.doc.index')) {
        count += value
      }
      if (key === 'claim_request' && checkAuthorization(props.redux, 'claim.request.index')) {
        count += value
      }
      if (key === 'pintu_kerjoo_sync_error' && checkAuthorization(props.redux, 'pintu-kerjoo.approval')) {
        count += value
      }
    }
    setNotificationCount(count)
  }, [props.redux.notifications])

  return (
    <>
      <div className='nav-left left-header p-0' style={{ flex: 1, minWidth: 0 }}>
        <ul className='nav-menus w-100'>
          {/* pl-lg-0: sejajarkan dengan konten; di < lg padding tetap untuk jarak dari tombol menu */}
          <li className='pl-lg-0' style={{ minWidth: 0, flex: 1 }}>
            <h5 className='mb-0' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {props.redux.company.name}
            </h5>
          </li>
        </ul>
      </div>
      <div className='nav-right right-header p-0' style={{ flex: '0 0 auto' }}>
        <ul className='nav-menus w-100'>
          {/*
          <li className='p-0'>
            <img className='rounded-circle' src={process.env.PUBLIC_URL + 'assets/images/default/profile.png'} alt='Logo' style={{ width: 35, height: 35 }} />
          </li>
          */}
          {(!props.redux.profile.supervisor_groups && props.redux.isTrial) && (
            <>
              <li className='p-0 d-none d-sm-block'>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  className='btn btn-primary'
                  style={{ letterSpacing: .5 }}
                  href='https://kerjoo.com/demo/?fp=btn-demo-home-admin'
                >
                  {LangScheduleDemo}
                </a>
              </li>
              {window.innerWidth >= 400 && window.innerWidth <= 575 && (
                <li className='p-0 d-sm-none pull-left'>
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    className='btn btn-sm btn-primary px-2'
                    style={{ letterSpacing: .5 }}
                    href='https://kerjoo.com/demo/?fp=btn-demo-home-admin'
                  >
                    {LangScheduleDemo}
                  </a>
                </li>
              )}
            </>
          )}
          <li className="onhover-dropdown ml-1 ml-xl-3 px-2">
            <div className={`notification-box ${notificationCount !== 0 && 'vibrate'} mt-1 mt-md-0`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"></path></svg>
              {
                notificationCount !== 0 &&
                <span className="badge badge-pill badge-secondary" style={{ right: `${notificationCount > 9 ? notificationCount > 99 ? '-12px' : '-10px' : '-5px'}` }}>{notificationCount > 99 ? '99+' : notificationCount}</span>
              }
            </div>
            <ul className="notification-dropdown onhover-show-div active">
              <li><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"></path></svg>
                <h6 className="f-18 mb-0">{LangNotification}</h6>
              </li>
              {
                props.redux.notifications.attendance_review !== 0 && checkAuthorization(props.redux, 'attendance-review.index') &&
                <li onClick={() => { history.push('/attendance/review') }}>
                  <p className='link'><i className="fa fa-circle-o mr-3 font-primary"> </i>{AttendanceReview} <span className="pull-right">{props.redux.notifications.attendance_review}{props.redux.notifications.over_limit?.indexOf('attendance_review') !== -1 ? '+' : ''}</span></p>
                </li>
              }
              {
                props.redux.notifications.attendance_edit_request !== 0 && checkAuthorization(props.redux, 'attendance-revision.index') &&
                <li onClick={() => { history.push('/attendance/revision') }}>
                  <p className='link'><i className="fa fa-circle-o mr-3 font-success"></i>{LangAttendanceRevision}<span className="pull-right">{props.redux.notifications.attendance_edit_request}{props.redux.notifications.over_limit?.indexOf('attendance_edit_request') !== -1 ? '+' : ''}</span></p>
                </li>
              }
              {
                props.redux.notifications.unlock_limit_attenance_request !== 0 && checkAuthorization(props.redux, 'attendance-approval.index') &&
                <li onClick={() => { history.push('/attendance-approval') }}>
                  <p className='link'><i className="fa fa-circle-o mr-3 font-info"></i>{LangAttendanceApproval}<span className="pull-right">{props.redux.notifications.unlock_limit_attenance_request}{props.redux.notifications.over_limit?.indexOf('unlock_limit_attenance_request') !== -1 ? '+' : ''}</span></p>
                </li>
              }
              {
                props.redux.notifications.update_profile_picture !== 0 && checkAuthorization(props.redux, 'picture-approval.index') &&
                <li onClick={() => { history.push('/attendance/profile-picture-approval') }}>
                  <p className='link'><i className="fa fa-circle-o mr-3 font-warning"></i>{LangProfilePhotoApproval}<span className="pull-right">{props.redux.notifications.update_profile_picture}{props.redux.notifications.over_limit?.indexOf('update_profile_picture') !== -1 ? '+' : ''}</span></p>
                </li>
              }
              {
                props.redux.notifications.whitelist_device !== 0 && checkAuthorization(props.redux, 'device-approval.index') &&
                <li onClick={() => { history.push('/device-approval') }}>
                  <p className='link'><i className="fa fa-circle-o mr-3 font-primary"></i>{LangDeviceApproval}<span className="pull-right">{props.redux.notifications.whitelist_device}{props.redux.notifications.over_limit?.indexOf('whitelist_device') !== -1 ? '+' : ''}</span></p>
                </li>
              }
              {
                props.redux.notifications.leave_request !== 0 && checkAuthorization(props.redux, 'paid-leave.day.index') &&
                <li onClick={() => { history.push('/leave/request') }}>
                  <p className='link'><i className="fa fa-circle-o mr-3 font-danger"></i>{LangPaidLeaveRequest}<span className="pull-right">{props.redux.notifications.leave_request}{props.redux.notifications.over_limit?.indexOf('leave_request') !== -1 ? '+' : ''}</span></p>
                </li>
              }
              {
                props.redux.notifications.permit_request !== 0 && checkAuthorization(props.redux, 'unpaid-leave.day.index') &&
                <li onClick={() => { history.push('/permit/request') }}>
                  <p className='link'><i className="fa fa-circle-o mr-3 font-primary"></i>{LangUnpaidLeaveRequest}<span className="pull-right">{props.redux.notifications.permit_request}{props.redux.notifications.over_limit?.indexOf('permit_request') !== -1 ? '+' : ''}</span></p>
                </li>
              }
              {
                props.redux.notifications.personnel_document_expired && props.redux.notifications.personnel_document_expired !== 0 && checkAuthorization(props.redux, 'employee.doc.index') ?
                  <li onClick={() => { history.push('/personnels') }}>
                    <p className='link'><i className="fa fa-circle-o mr-3 font-success"></i>{LangEmployeeDocsExpired}<span className="pull-right">{props.redux.notifications.personnel_document_expired}{props.redux.notifications.over_limit?.indexOf('personnel_document_expired') !== -1 ? '+' : ''}</span></p>
                  </li> : ''
              }
              {
                props.redux.notifications.personnel_document_in_reminder && props.redux.notifications.personnel_document_in_reminder !== 0 && checkAuthorization(props.redux, 'employee.doc.index') ?
                  <li onClick={() => { history.push('/personnels') }}>
                    <p className='link' data-tip={LangEmployeeDocsInReminder}><i className="fa fa-circle-o mr-3 font-info"></i>{cookies.get('lang') === 'EN' ? LangEmployeeDocsInReminder : widthWindow >= 375 && widthWindow <= 425 ? LangEmployeeDocsInReminder.substring(0, 32) : `${LangEmployeeDocsInReminder.substring(0, 23)}...`}<span className="pull-right">{props.redux.notifications.personnel_document_in_reminder}{props.redux.notifications.over_limit?.indexOf('personnel_document_in_reminder') !== -1 ? '+' : ''}</span></p>
                  </li> : ''
              }
              {
                props.redux.notifications.claim_request && props.redux.notifications.claim_request !== 0 && checkAuthorization(props.redux, 'claim.request.index') ?
                  <li onClick={() => { history.push('/claim/request') }}>
                    <p className='link'><i className="fa fa-circle-o mr-3 font-danger"></i>{LangClaimRequest}<span className="pull-right">{props.redux.notifications.claim_request}{props.redux.notifications.over_limit?.indexOf('claim_request') !== -1 ? '+' : ''}</span></p>
                  </li> : ''
              }
              {
                props.redux.notifications.pintu_kerjoo_sync_error && props.redux.notifications.pintu_kerjoo_sync_error !== 0 && checkAuthorization(props.redux, 'pintu-kerjoo.approval') ?
                  <li onClick={() => { history.push('/pintu-kerjoo/attendance-approval') }}>
                    <p className='link' data-tip={LangPintuKerjooAttendanceApproval}><i className="fa fa-circle-o mr-3 font-primary"></i>{widthWindow >= 375 && widthWindow <= 425 ? `${LangPintuKerjooAttendanceApproval.substring(0, 36)}` : `${LangPintuKerjooAttendanceApproval.substring(0, 26)}...`}<span className="pull-right">{props.redux.notifications.pintu_kerjoo_sync_error}{props.redux.notifications.over_limit?.indexOf('pintu_kerjoo_sync_error') !== -1 ? '+' : ''}</span></p>
                  </li> : ''
              }
              <li className={`${notificationCount !== 0 && 'p-0'}`}>
                {
                  notificationCount === 0 && <p>{LangNoNotification}</p>
                }
              </li>
            </ul>
            <ReactTooltip place='bottom' />
          </li>
          <li className='onhover-dropdown border rounded ml-1 ml-xl-3 px-2'>
            <div className='d-flex align-items-center'>
              <span style={{ fontSize: 16, marginLeft: 5, fontWeight: 'bold' }}><span className=''>{Hi}, </span>
                <span style={{ fontWeight: 'normal' }}>
                  {
                    widthWindow >= 1043 ?
                      (
                        propsName && propsName.length > 18 ?
                          <span data-tip={propsName}>{propsName.slice(0, 18) + '...'}</span>
                          : propsName || ''
                      )
                      :
                      widthWindow >= 992 && widthWindow <= 1042 ?
                        (
                          propsName && propsName.length > 9 ?
                            <span data-tip={propsName}>{propsName.slice(0, 9) + '...'}</span>
                            : propsName || ''
                        )
                        :
                        widthWindow >= 796 && widthWindow <= 991 ?
                          (
                            propsName && propsName.length > 18 ?
                              <span data-tip={propsName}>{propsName.slice(0, 18) + '...'}</span>
                              : propsName || ''
                          )
                          :
                          widthWindow >= 425 && widthWindow <= 795 ?
                            (
                              propsName && propsName.length > 9 ?
                                <span data-tip={propsName}>{propsName.slice(0, 9) + '...'}</span>
                                : propsName || ''
                            )
                            :
                            widthWindow >= 375 ?
                              limitName.length > 9 ?
                                `${name.substring(0, 8)}...` || ''
                                :
                                name || ''
                              :
                              limitName.length > 9 ?
                                `${name.substring(0, 8)}...` || ''
                                :
                                name || ''
                  }
                </span>
              </span>
              <i className='middle fa fa-angle-down ml-2' />
            </div>
            <ul className='profile-dropdown onhover-show-div active' style={{ top: 38 }}>
              <li><a onClick={() => { history.push('/admin/activity-logs') }} className='d-flex align-items-center'><FontAwesomeIcon icon={faHistory} /> <span>{LangActivity}</span></a></li>
              {/* <li><a onClick={() => { history.push('/admin/daily-report') }} className='d-flex align-items-center'><FontAwesomeIcon icon={faCalendarDay} /> <span>{LangDailyReport}</span></a></li> */}
              <li><a onClick={() => { history.push('/admin/setting') }} className='d-flex align-items-center'><FontAwesomeIcon icon={faCog} /> <span>{LangSetting}</span></a></li>
              <li>
                <a onClick={() => !onLogout && setLogout(true)} className='text-danger d-flex align-items-center'>
                  {onLogout ? <div className='mr-2'>{SpinnerButton}</div> : <FontAwesomeIcon icon={faSignOutAlt} />} <span className='text-danger'>{LangLogout}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </>

  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Rightbar)
